export default __webpack_public_path__ + "static/media/potcoin.35dc0e00.png";